import { decodeHtmlEntities } from '@opallabs/lambda'

/**
 * Parses the asset UUID from the asset proxy URL.
 * This is necessary sometimes because the asset reference doesn't
 * always have the asset UUID, e.g. from Elasticsearch results.
 */
const parseAssetUuidFromUrl = (url) => {
  if (!url) return null
  const re = /api\/v1\/asset_proxy\/([a-f0-9-]*)$/i.exec(url)
  return re !== null ? re[1] : null
}

/**
 * @param {import('@opallabs/cassini').AssetReference} assetRef
 * @returns {import('@opallabs/text-editor').TextEditorAsset}
 */
export const setTextEditorAssetData = (assetRef) => {
  return {
    assetUuid: assetRef.asset_uuid ?? parseAssetUuidFromUrl(assetRef.full_url),
    assetType: assetRef.asset_type ?? null,
    filename: decodeHtmlEntities(assetRef.filename),
    filesize: assetRef.filesize,
    format: assetRef.format,
    fullUrl: assetRef.full_url,
    previewUrl: assetRef.preview_url,
    width: assetRef.width,
    height: assetRef.height,
  }
}
